import { useContext } from 'react';
import ReactDom from 'react-dom';

import styled from '@emotion/styled';

import { ModalContext } from '../../context/ModalContext';

interface IModal {
  children: React.ReactNode;
}

export const Modal: React.FC<IModal> = ({ children }) => {
  const modalRoot = document.getElementById('modal-root');
  const modalContext = useContext(ModalContext);

  return ReactDom.createPortal(
    <ModalContainer className={modalContext?.showModal ? '' : 'closeModal'}>
      {children}
    </ModalContainer>,
    modalRoot!
  );
};

const ModalContainer = styled.div`
  position: fixed;
  padding-top: 10rem;
  padding-bottom: 5rem;
  overflow: auto;
  top: 0;
  width: 100vw;
  height: 100vh;
  isolation: isolate;
  background: rgba(217, 217, 217, 0.5);
  /* z-index: 1; */
  /* backdrop-filter: blur(4px); */
  display: grid;
  justify-content: center;
  /* place-content: center; */

  & > * {
    height: fit-content;
  }

  &.closeModal {
    display: None;
  }
`;
